import React, { useState, useEffect, useRef } from 'react';
import CloseButton from './CloseButton';
import v from '../../utils/Verifiers';
import { Html5QrcodeScanner } from 'html5-qrcode';
import { dateFormatConDia, dateFormatConDiaYHoraShort } from '../../utils/DateFunctions';
import errorImage from '../../assets/advertencia.png';

const EscanerBarcodeActividades = (p) => {
    const close = p.close ?? (() => { });
    const scannerRef = useRef(null);
    var folio = '';
    const [loader, setloader] = useState(false);
    const ldr = (<div className='w-100 h-100 blur-xl bg-white4' style={{ position: "absolute", top: 0, left: 0, zIndex: 9999 }}><div className='loader-local' /></div>);
    const [dialog, setdialog] = useState({ show: false });
    const [data, setdata] = useState(null);
    const [errorLoad, seterrorLoad] = useState(null);

    useEffect(() => {
        const config = { fps: 24, qrbox: { width: 600, height: 150 }, aspectRatio: 3.5, };
        const html5QrcodeScanner = new Html5QrcodeScanner(
            "reader",
            config,
            false
        );

        html5QrcodeScanner.render(
            (decodedText, decodedResult) => {
                if (decodedText === folio) return;
                folio = decodedText;
                getRegistroFromBarcode(decodedText);
            },
            (errorMessage) => {
            }
        );

        return () => {
            html5QrcodeScanner.clear().catch(error => {
                console.error('Failed to clear html5QrcodeScanner. ', error);
            });
        };

    }, []);

    const getRegistroFromBarcode = async (id) => {
        let resp = await v.getDataAPI('ordenes_trabajo/siembra/etiquetas/lector', { id }, setloader, false);
        if (!resp.estatus) {
            seterrorLoad(resp.msj);
            setdata(null);
            setTimeout(() => {
                if (errorLoad !== null) seterrorLoad(null);
            }, 3000);
            return;
        }
        seterrorLoad(null);
        setdata(resp.data);
    }

    const realizarCharola = async (id) => {
        let resp = await v.getDataAPI('ordenes_trabajo/siembra/etiquetas/lector/actualizar', { id }, setloader, false);
        if (!resp.estatus) {
            seterrorLoad(resp.msj);
            setdata(null);
            setTimeout(() => {
                if (errorLoad !== null) seterrorLoad(null);
            }, 3000);
            return;
        }
        seterrorLoad(null);
        setdata(resp.data);
    }

    return (
        <div className='vh-100 vw-100 text-center blur-xl dosis bg-white5 m-0 p-1' style={v.floatPageStyle()}>
            <CloseButton close={() => close()}
                buttonStyle='btn btn-sm btn-danger bg-red3 m-0 shadow ps-0 bw-100 scale-continue-05 border border-warning border-3 text-bold round-xxl'
                containerStyle='w-100 p-0 pb-0 text-end m-0'
            />
            <div className='row justify-content-evenly w-100 m-0 p-0'>

                <div className='bw-700  shadow-multi p-2 m-0 bg-light round-s blur-xxl' style={{ position: "relative", height: '90vh', overflow: 'auto' }}>
                    <div className='row justify-content-evenly w-100 m-0 p-0'>

                        <div id="reader" ref={scannerRef} ></div>
                        {!errorLoad && !data && <div className='w-100 text-bold text-bold h4 mt-4 text-center '>Escanea el código de barras de la etiqueta para desplegar las opciones</div>}
                        {errorLoad && <>
                            <div className='row justify-content-evenly w-100 m-0 p-0'>
                                <img src={errorImage} className='mt-3' style={{ width: "70px", height: "auto" }} />
                                <div className='w-100' />
                                <div className='col-auto text-red3 text-bold mt-3 p-2 round-m border border-danger border-2 scale-025 pointer' onClick={() => { seterrorLoad(null) }}>
                                    {errorLoad}
                                </div>
                            </div>

                        </>}
                        {data && <>
                            <div className='bw-600 bg-light shadow-multi-sm mt-2 border border-warning round-m p-1 mb-4'>
                                <div className='row justify-content-evenly w-100 m-0 p-0'>
                                    <div className='w-100 text-bold text-l text-red3'>{data.bloque}</div>
                                    <div className='w-100 text-bold mb-0 text-s opacity-70'>
                                        <span className='text-s me-1 text-300'>Folio de charola:</span>
                                        {data.id}
                                    </div>
                                </div>
                            </div>

                            <div className='bw-600 bg-white round-m p-1 mb-3'>
                                <div className='row justify-content-evenly w-100 m-0 p-0'>
                                    <div className='w-100 text-bold'><span className='text-s me-2 text-300'>Fecha de siembra:</span> {dateFormatConDia(data.fecha_programado)}</div>

                                    <div className='w-100 text-bold'>
                                        <span className='text-s me-1 text-300'>S. siembra:</span> {data.semana}-{data.dia + 1}
                                        <span className='text-s me-1 ms-3 text-300'>S. transp.:</span> {data.trasplante}
                                        <span className='text-s me-1 ms-3 text-300'>S. corte:</span> {data.cosecha}
                                    </div>
                                </div>
                            </div>

                            <div className='bw-600 bg-white round-m p-1 mb-3'>
                                <div className='row justify-content-evenly w-100 m-0 p-0'></div>
                                <div className='w-100 text-bold m-0 mb-0 text-l text-blue3'>
                                    <span className='text-s me-1 text-300'>Responsable:</span>
                                    {data.asignado_a}
                                </div>
                                <div className={`w-100 text-bold opacity-70 text-s mt-0 mb-0`}>
                                    <span className='text-s me-1 text-300'>Asignado por:</span>
                                    {data.asignado_por}
                                </div>
                                <div className={`w-100 text-bold opacity-70 text-s mt-0 mb-0`}>
                                    <span className='text-s me-1 text-300'>Fecha de asignación:</span>
                                    {dateFormatConDiaYHoraShort(data.fecha_asignacion)}
                                </div>
                            </div>

                            {data.fecha_realizado && <div className={`col-auto text-bold text-green3 border round-l border-success border-2 text-s mt-0 mb-0`}>
                                <span className='text-s me-1 text-300'>Sembrado:</span>
                                {dateFormatConDiaYHoraShort(data.fecha_realizado)}
                            </div>}
                            {!data.fecha_realizado && data.puede_editar_siembra && <div className="w-100 mb-3 contenedor">
                                <button className='btn btn-sm mt-1 mb-1 btn-warning shadow bw-300 round-xxl border border-3 text-l text-bold border-dark scale-025'
                                    onClick={() => { realizarCharola(data.id) }}
                                >Marcar siembra como realizada</button>

                            </div>}
                        </>}

                    </div>
                    {loader && ldr}
                </div>
            </div >
        </div >
    )
}

export default EscanerBarcodeActividades;